// @flow

import React, { Component } from 'react'
// $FlowFixMe
import { Field } from 'redux-form'
import styled, { css } from 'styled-components'
import { renderField, renderSelect, renderNativeSelect } from 'src/helpers/fieldRenderers'
import { required } from 'src/helpers/validation'
import { NATIONALITIES } from 'src/helpers/constants'

type Props = {
  isPadded?: boolean
}

const StyledAddress = styled.div`
  ${(props: Props) =>
    props.isPadded &&
    css`
      padding: 0 40px;
    `};
`

class Address extends Component<Props> {
  render() {
    const mq = window.matchMedia('(min-width: 480px)')
    return (
      <StyledAddress isPadded={this.props.isPadded}>
        <Field
          name="addressLine1"
          type="text"
          component={renderField}
          label="Address Line 1"
          validate={[required]}
        />
        <Field name="addressLine2" type="text" component={renderField} label="Address Line 2" />
        <Field name="city" type="text" component={renderField} label="City" validate={[required]} />
        <Field
          name="nationality"
          type="text"
          component={mq.matches ? renderSelect : renderNativeSelect}
          options={NATIONALITIES}
          label="Country"
          autocomplete="nationality"
          validate={[required]}
        />
        <Field
          name="postCode"
          type="text"
          component={renderField}
          label="Post Code"
          validate={[required]}
        />
      </StyledAddress>
    )
  }
}

export default Address



// WEBPACK FOOTER //
// ./src/components/Form/Address.js